import { ReactNode } from 'react'

export type ProductType = {
  id: Products
  title: string
  blocks: number
  enabled?: boolean
  invalidPercentage: number
  image: ReactNode
  link: string
  riskLevel: Risk
  connected: ConnectionState
}

export const CONNECTION_STATE = {
  CONNECTED: 'Connected',
  PARTIALLY_CONNECTED: 'Partially Set',
  NOT_CONNECTED: 'Not Connected',
} as const

export type LABEL_VARIANT = 'success' | 'warning' | 'default' | 'critical' | 'high'

export const CONNECTION_TO_VARIANT: { key: ConnectionState; background: LABEL_VARIANT }[] = [
  { key: 'Connected', background: 'success' },
  { key: 'Partially Set', background: 'warning' },
  { key: 'Not Connected', background: 'default' },
]

export const RISKS_TO_LABEL_VARIANT: { key: Risk; background: LABEL_VARIANT }[] = [
  { key: 'High', background: 'high' },
  { key: 'Critical', background: 'critical' },
  { key: 'Medium', background: 'warning' },
  { key: 'Low', background: 'success' },
]

export const MEDIUM_PERCENTAGE = 0.5
export const HIGH_PERCENTAGE = 3
export const CRITICAL_PERCENTAGE = 5

type connectionStateType = typeof CONNECTION_STATE
export type ConnectionState = connectionStateType[keyof typeof CONNECTION_STATE]

export const RISKS = {
  HIGH: 'High',
  CRITICAL: 'Critical',
  LOW: 'Low',
  MEDIUM: 'Medium',
} as const

type riskStateType = typeof RISKS
export type Risk = riskStateType[keyof typeof RISKS]

export type Products = 'paidMarketing' | 'botZapping'
